import React from 'react';
import { FiFilter, FiSearch } from 'react-icons/fi';

interface TableSearchFilterProps {
  searchValue?: string;
  searchPlaceholder?: string;
  placeholder?: string;
  onSearchChange?: (value: string) => void;
  onFilterClick?: () => void;
  onToggleFilterPanel?: () => void;
  onClearSearch?: () => void;
  showFilterPanel?: boolean;
  fullWidthSearch?: boolean;
  showFilterButton?: boolean; // Add new prop to control filter button visibility
}

const TableSearchFilter: React.FC<TableSearchFilterProps> = ({
  searchValue = '',
  searchPlaceholder = 'Search here...',
  placeholder = 'Search here...',
  onSearchChange,
  onFilterClick,
  onToggleFilterPanel,
  onClearSearch,
  showFilterPanel,
  fullWidthSearch = true,
  showFilterButton = true, // Default to showing the filter button
}) => {
  return (
    <div className="flex justify-between items-center space-x-2 overflow-x-auto">
      <div className="relative w-full">
        <FiSearch size={16} className="absolute top-4 left-3 text-gray-400" />
        <input
          type="text"
          value={searchValue}
          placeholder={placeholder || searchPlaceholder}
          className="pl-10 pr-10 h-11 border rounded-full w-full outline-none focus:border-sky-400 transition-colors text-sm bg-white"
          onChange={e => onSearchChange && onSearchChange(e.target.value)}
        />
        {searchValue && onClearSearch && (
          <button
            onClick={onClearSearch}
            className="absolute right-3 top-3.5 text-gray-400 hover:text-gray-600"
            aria-label="Clear search"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-4 w-4"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        )}
      </div>
      {showFilterButton && (
        <button
          className={`flex-shrink-0 flex items-center px-4 h-11 border rounded-full text-gray-700 hover:bg-gray-100 text-sm ${showFilterPanel ? 'bg-gray-100' : ''}`}
          onClick={onToggleFilterPanel || onFilterClick}
        >
          <FiFilter size={16} className="mr-2" />
          Filter
        </button>
      )}
    </div>
  );
};

export default TableSearchFilter;
